module.exports = __webpack_public_path__ + "home/en-US/images/icon_preview-2ebff5b6f613ae81a567c8f64ca92f00.png";


//////////////////
// WEBPACK FOOTER
// ./home/en-US/images/icon_preview.png
// module id = b7kW
// module chunks = 0